import { render, staticRenderFns } from "./CustomLink.vue?vue&type=template&id=4dc9a335&scoped=true&"
import script from "./CustomLink.vue?vue&type=script&lang=js&"
export * from "./CustomLink.vue?vue&type=script&lang=js&"
import style0 from "./CustomLink.vue?vue&type=style&index=0&id=4dc9a335&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9a335",
  null
  
)

export default component.exports